import React, { FC } from "react";

import PolicyPage from "../PolicyPage/PolicyPage";
import { PolicyFileType } from "../PolicyPage/utils";

const TermsOfUsePage: FC = () => {
    return <PolicyPage type={PolicyFileType.terms} />;
};

export default TermsOfUsePage;
